'use client'

// Self-contained footer-newsletter form hook (Phase B: UI ephemera off Overmind).
//
// The email buffer + submit status/loading now live in LOCAL React state instead
// of the Overmind `footerEmailForm` slice — this data is transient, single-widget
// UI ephemera with no cross-request or cross-component meaning. The submit posts
// directly through the same same-origin `/api/addUserToMainMailingList` endpoint
// the old `footerEmailFormSubmitted` action used (via the plain `http` effect
// module, which is a pure fetch wrapper with no Overmind coupling), and fires the
// identical `newsletter_signup` dataLayer event — so behavior is byte-identical.
//
// Consumers (NewsletterFormIsland, the legacy Footer) keep the SAME return shape,
// so the read-seam contract is unchanged.

import { useState } from 'react'
import { http } from '../../utils/clientHttp'
import { pushDataLayerEvent } from '../../utils/dataLayer'

export function useNewsletterForm() {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const resetStatusMessages = () => {
    setSuccessMessage(null)
    setErrorMessage(null)
  }

  const submit = () => {
    setIsLoading(true)
    resetStatusMessages()
    http
      .post('/api/addUserToMainMailingList', { email })
      .then((response) => {
        console.log('response', response)
        setSuccessMessage('Thank you for subscribing to our newsletter!')
        pushDataLayerEvent('newsletter_signup', {
          list: 'main_newsletter',
          user_data: { email },
        })
      })
      .catch((e) => {
        console.log('Bad request', e.message)
        setErrorMessage(e.message)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return {
    email,
    isLoading,
    successMessage,
    errorMessage,
    setEmail,
    submit,
    resetStatusMessages,
  }
}
